import { getApiClient } from '@/api/client';
import { getContracts } from '@/api/generated/endpoints/contracts/contracts';
import type { GetContractsParams } from '@/api/generated/models';
import { parseResponse } from '@/api/parseResponse';
import { ContractDetails, ContractPage } from '@/api/schemas';

export async function searchContracts(
  params: GetContractsParams,
): Promise<ContractPage> {
  const response = await getContracts(getApiClient()).getContracts(params);
  return parseResponse(ContractPage, response.data, 'contract search');
}

export async function getContractDetails(
  contractId: string,
): Promise<ContractDetails> {
  const response = await getContracts(getApiClient()).getContractById(
    contractId,
  );
  return parseResponse(ContractDetails, response.data, 'contract');
}

export async function downloadPolicyDocument(
  policyNumber: string,
): Promise<Blob> {
  const response = await getContracts(getApiClient()).downloadPolicyDocument(
    policyNumber,
  );
  return response.data;
}
